import Client from './client';

export default class OrderManagementEvents extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  postReplayByOrderLifecycleEvent(organization, number, orderLifecycleEvent, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/orders/${number}/lifecycle/events/${orderLifecycleEvent}/replay`, {
      ...options,
       method: 'POST',
    });
  }

}
